import React from "react";
import {
  BookedCourtsResponse,
  BookingDetailsResponsePlayers,
} from "../../../apis/types";
import { UserAvatar } from "../../../components/userAvatar/UserAvatar";
import { ULTRA_AI_PLAYERS_ID } from "../../../utils/data";

type props = {
  match: BookedCourtsResponse;
};

export const MatchPlayers: React.FC<props> = ({ match }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: -8 }}>
      {match.players.map((avatar: BookingDetailsResponsePlayers, i: number) => (
        <UserAvatar
          key={i}
          avatar={{
            image: ULTRA_AI_PLAYERS_ID.find(
              (v) => v.id === avatar.id.toString()
            )
              ? ULTRA_AI_PLAYERS_ID.find((v) => v.id === avatar.id.toString())
                  ?.icon ?? ""
              : avatar.profileImageUrl,
            name: avatar.name,
          }}
          size={30}
          style={{
            marginLeft: i === 0 ? 0 : -12,
            border: "2px solid #fff",
          }}
          nameStyle={{ fontSize: 12 }}
        />
      ))}
    </div>
  );
};
